export type SignInErrorCode =
    | 'invalidCredentials'
    | 'rateLimited'
    | 'unavailable'
    | 'invalidSession'
    | 'network'
    | 'timeout'

export class SignInError extends Error {
    readonly code: SignInErrorCode

    constructor(code: SignInErrorCode) {
        super(code)
        this.name = 'SignInError'
        this.code = code
    }
}

export function getSignInErrorCode(error: unknown): SignInErrorCode {
    if (error instanceof SignInError) return error.code

    if (error instanceof TypeError) return 'network'

    if (error instanceof DOMException && error.name === 'TimeoutError') {
        return 'timeout'
    }

    return 'unavailable'
}
